import { MessageBox } from "element-ui";
import router from "@/router/index";
import { getToken, removeToken } from "@/utils/auth";

/** 登录失效弹窗是否已展示，避免并发请求重复弹窗 */
const isRelogin = { show: false };

/**
 * 统一处理登录态失效：提示用户重新登录，确认后清理凭证并跳转登录页
 * axios 拦截器与 SSE 流式请求共用，保证两条链路行为一致
 */
export function handleSessionExpired() {
  if (isRelogin.show) return;
  isRelogin.show = true;

  const token = getToken();
  const message = token
    ? "登录状态已过期，您可以继续留在该页面，或者重新登录"
    : "暂未登录，您可以继续留在该页面，或者去登录";

  MessageBox.confirm(message, "系统提示", {
    confirmButtonText: "登录",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      removeToken();
      router.push("/login");
    })
    .catch(() => {
      isRelogin.show = false;
    });
}
